import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
//import material icons
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
//import core components
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class OrganizationDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            name: "",
            is_master: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.organizationData && !nextProps.organizationData.isNew
                && nextProps.isOpened && !this.props.isOpened){
            this.setState({
                ...nextProps.organizationData,
            })
        }
        if (!nextProps.isOpened){
            this.setState({
                name: "",
                is_master: false,
            })
        }
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    _changeCheckerHandler(e, type) {
        this.setState((prevState) => ({
            ...prevState,
            [type]: !prevState[type],
        }))
    }

    render(){
        const { classes, onCancel, onSave, isOpened, isNew} = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >{isNew ? "Создание новой" : "Редактирование" } организации</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <Grid container>
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Название"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.name,
                                    onChange: e => this._changeValue(e, "name")
                                }}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.is_master}
                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                        icon={<Check className={classes.uncheckedIcon} />}
                                        classes={{ checked: classes.checked }}
                                        onChange={(e) => this._changeCheckerHandler(e, "is_master")}
                                    />
                                }
                                classes={{ label: classes.label }}
                                label="Мастер организация"
                            />
                        </GridItem>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave(this.state)}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

OrganizationDialog.propTypes = {
    isOpened: PropTypes.bool,
    isNew: PropTypes.bool,
    organizationData: PropTypes.object,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    organization: PropTypes.number,
};

export default withStyles(modalStyle)(OrganizationDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/OrganizationDialog.jsx